module.exports = __webpack_public_path__ + "img/5.3c74708d.jpg";